import { isNumeric } from '../../util/helpers';

import { LatLon } from '../../util/geodesy/latlon';


/**
 * Parses a lat/lon from individual strings into a LatLon instance
 * @param lat {any} Latitude
 * @param lon {any} Longitude
 * @return {LatLon} Parsed LatLon (or null if can't be parsed)
 */
export function parseLatLon(lat: any, lon: any): LatLon {
  return isNumeric(lat) && isNumeric(lon) ? new LatLon(+lat, +lon) : null;
}
